import { RouteObject, useRoutes } from 'react-router-dom';
import { PrivateLayout } from 'Components';
import { UniversalRequestLayout } from 'Components/UniversalRequestLayout';
import { ErrorLayout } from 'Components/ErrorLayout';
import { SuppliersLayout } from 'Components/SuppliersLayout';
import * as components from './components';
import { CreateOrderWrapper } from 'Modules/MedicationsAndPrescriptionsLobby/CreateOrderWrapper';
import { EmergencyCallLayout } from 'Components/EmergencyCallLayout';
import { IFrameLayout } from 'Components/IframeLayout';
import { CalculatorLayout } from 'Components/CalculatorLayout';

export const Router = () => {
  const privateRoutesConfig: RouteObject[] = [
    // PrivateLayout routes
    {
      element: <IFrameLayout />,
      children: [
        {
          path: '/IframeApplies',
          children: [
            {
              index: true,
              element: <components.IframeAppliesLobby />,
            },
            { path: ':id', element: <components.IframeAppliesLobby /> },
          ],
        },
        {
          path: '/IframeMedicalReferrals',
          children: [
            { index: true, element: <components.IframeMedicalReferrals /> },
            { path: ':id', element: <components.IframeMedicalReferrals /> },
          ],
        },
        {
          path: '/IframeLongtermEquipment',
          element: <components.IframeLongtermEquipment />,
        },
        {
          path: '/IframePaymentsAndDeductions',
          element: <components.IframePaymentsAndDeductions />,
        },
      ],
    },
    {
      element: <PrivateLayout />,
      children: [
        {
          path: '/',
          index: true,
          element: <components.Home />,
        },
        {
          path: '/activities-lobby',
          element: <components.ActivitiesLobby />,
        },
        {
          path: '/medicine',
          children: [
            {
              index: true,
              element: <components.MedicationsAndPrescriptionsLobby />,
            },
            {
              path: 'MedicationHistory',
              element: <components.MedicationHistory />,
            },
            {
              path: 'ExpiredMedications',
              element: <components.ExpiredMedicationsLobby />,
            },
            { path: 'createOrder', element: <CreateOrderWrapper /> },
            { path: 'createOrder/:id', element: <CreateOrderWrapper /> },
            { path: ':id', element: <components.MedicineOrderInfo /> },
          ],
        },
        {
          path: '/recognitionStatus',
          children: [
            { index: true, element: <components.Status /> },
            { path: ':claimEventNumber', element: <components.SingleStatus /> },
          ],
        },
        {
          path: '/paychecks',
          children: [
            { index: true, element: <components.Paychecks /> },
            { path: ':tabId', element: <components.Paychecks /> },
          ],
        },
        {
          path: '/Applies',
          children: [
            { index: true, element: <components.AppliesLobby /> },
            { path: ':id', element: <components.AppliesLobby /> },
          ],
        },
        {
          path: '/Admin/Applies',
          element: <components.AppliesLobby />,
        },
        {
          path: '/Equipment',
          children: [
            { index: true, element: <components.Equipment /> },
            {
              path: '/Equipment/CreateOrder',
              children: [
                { index: true, element: <components.EquipmentCreateOrder /> },
                { path: ':id', element: <components.EquipmentCreateOrder /> },
              ],
            },
            { path: ':id', element: <components.EquipmentOrderInfo /> },
          ],
        },
        {
          path: '/requests',
          children: [
            {
              path: ':formName/:id/:subId',
              element: <components.Requests />,
            },
            {
              path: ':formName/:id/:subId/:sectionId',
              element: <components.Requests />,
            },
          ],
        },
        {
          path: '/test-links',
          element: <components.TestLinks />,
        },
        {
          path: '/test-components',
          element: <components.TestComponents />,
        },
        {
          path: '/test-images',
          element: <components.TestImages />,
        },
        {
          path: '/forms-details',
          element: <components.FormsDetails />,
        },
        {
          path: '/confirmations/:docType',
          element: <components.Confirmations />,
        },
        {
          path: '/personal-details',
          children: [
            { index: true, element: <components.PersonalDetails /> },
            { path: ':detailType', element: <components.PersonalDetails /> },
          ],
        },
        {
          path: '/personal-team',
          element: <components.PersonalTeam />,
        },
        {
          path: '/compass-rights',
          children: [
            { index: true, element: <components.CompassRights /> },
            { path: ':id', element: <components.CompassRightsEntitlement /> },
          ],
        },
        {
          path: '/medical-referrals',
          children: [
            { index: true, element: <components.MedicalReferrals /> },
            { path: ':id', element: <components.MedicalReferrals /> },
          ],
        },
        {
          path: '/disabled-veteran',
          element: <components.DisabledVeteran />,
        },
        {
          path: '/treatment',
          element: <components.Treatment />,
        },
        {
          path: '/eshet-tours',
          element: <components.EshetTursRedirect />,
        },
        {
          path: '/flying-carpet',
          element: <components.FlyingCarpetRedirect />,
        },
        {
          path: '/payments&deductions',
          element: <components.PaymentsAndDeductions />,
        },
        {
          path: '/documents',
          element: <components.DocumentsOld />,
        },
        {
          path: '/documents-new',
          element: <components.Documents />,
        },
        {
          path: '/admin/documents',
          element: <components.DocumentsOld />,
        },
        { path: '/Updates', element: <components.Updates /> },
        {
          path: '/disability-confirmations',
          element: <components.DisabilityConfirmations />,
        },
        {
          path: '/longterm-equipment',
          element: <components.LongtermEquipment />,
        },
        {
          path: '/contact-details',
          element: <components.B2CFirstLoginLanding />,
        },
        {
          path: '/Reimbursements',
          children: [
            { index: true, element: <components.Reimbursements /> },
            { path: 'Cannabis', element: <components.Cannabis /> },
            {
              path: 'Alternative-medicine',
              element: <components.AlternativeMedicine />,
            },
            { path: 'Family-members', element: <components.FamilyMembers /> },
          ],
        },
        {
          path: '/lawyers-lobby',
          element: <components.LawyersLobby />,
        },
        {
          path: '/search-results',
          element: <components.SearchResults />,
        },
        // medical-committees routes
        {
          path: '/medical-committees',
          children: [
            { index: true, element: <components.Lobby /> },
            { path: ':id', element: <components.Committee /> },
            { path: 'add-contact', element: <components.AddContactForm /> },
            {
              path: 'add-contact/success',
              element: <components.ContactSuccess />,
            },
            { path: 'finished', element: <components.CompletedCommittees /> },
            { path: 'recordings', element: <components.RecordingsLobby /> },
          ],
        },
        {
          path: '/admin/feedback',
          element: <components.FeedbackAdmin />,
        },
        {
          path: '/admin/emergency-call',
          children: [
            {
              index: true,
              element: <components.AdminEmergencyCall />,
            },
            {
              path: 'agents',
              element: <components.AdminEmergencyCallAgents />,
            },
          ],
        },
        {
          path: '/admin/data-analysis',
          element: <components.DataAnalysisLobby />,
        },
        {
          path: '/admin/data-analysis/prompt-manager',
          element: <components.DataAnalysisPromptManager />,
        },
        {
          path: '/admin/dashboard/recognition-form',
          element: <components.RecognitionDashboard />,
        },
        {
          path: '/medical-car',
          element: <components.MedicalCar />,
        },
        {
          path: '/maintenance',
          element: <components.MaintenancePage />,
        },
      ],
    },
    // UniversalRequestLayout routes
    {
      element: <UniversalRequestLayout />,
      path: '/universalRequest',
      children: [
        { index: true, element: <components.UniversalRequest /> },
        { path: ':tabId', element: <components.UniversalRequest /> },
        {
          path: ':tabId/:categoryId',
          element: <components.UniversalRequest />,
        },
        {
          path: ':tabId/:categoryId/:subCategoryId',
          element: <components.UniversalRequest />,
        },
      ],
    },
    // EmergencyCallLogin routes
    {
      element: <EmergencyCallLayout />,
      path: '/emergency-call/login',
      children: [{ index: true, element: <components.EmergencyCallLogin /> }],
    },
    // SuppliersLayout routes
    {
      element: <SuppliersLayout />,
      path: '/suppliers',
      children: [
        { index: true, element: <components.Suppliers /> },
        { path: ':supplierCategory', element: <components.Suppliers /> },
        {
          path: ':supplierCategory/results',
          element: <components.Suppliers />,
        },
        {
          path: ':supplierCategoryId/results/:supplierSpecialty/:supplierId',
          element: <components.SingleSupplier />,
        },
      ],
    },
    // CalculatorLayout routes
    {
      element: <CalculatorLayout />,
      path: '/disability-calculator',
      children: [{ index: true, element: <components.DisabilityCalculator /> }],
    },
    // Standalone routes
    { path: '/auth-loader', element: <components.AuthLoader /> },
    {
      path: '/error',
      element: <ErrorLayout />,
      children: [{ index: true, element: <components.Error /> }],
    },
    { path: '/b2cError', element: <components.B2CError /> },
    {
      path: '/emergency-call',
      element: <EmergencyCallLayout />,
      children: [{ index: true, element: <components.EmergencyCall /> }],
    },
  ];

  const generatedRoutes = useRoutes(privateRoutesConfig);

  return generatedRoutes;
};
